
    import '/home/ec2-user/Youlify-Design/components/carousel/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["carousel-demo-basic","carousel-demo-position","carousel-demo-autoplay","carousel-demo-fade","carousel-demo-arrows","carousel-demo-dot-duration","carousel-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/carousel/index.zh-CN.md?type=demo')
};